import React from 'react';
import classNames from 'classnames';

import css from './WishlistCard.module.css';

/**
 * Menu icon - 3 dots icon for context menu
 *
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {boolean} [props.isActive] - Whether the menu is active
 * @returns {JSX.Element} Menu icon component
 */
const MenuIcon = props => {
  const { className } = props;
  const classes = classNames(css.menuIcon, className);

  return (
    <span className={classes} role="none">
      <span className={css.menuDot} />
      <span className={css.menuDot} />
      <span className={css.menuDot} />
    </span>
  );
};

export default MenuIcon;
